import React from 'react';
import { Flex, FlexProps, LinkProps, Text } from 'rebass';
import IconLink from '../Icon/IconLink';
import StatusDot, { StatusStyle } from '../Status/StatusDot';

const KeyValLink: React.FC<LinkProps> = ({
  children,
  ...props
}): JSX.Element => {
  return (
    <IconLink
      {...(props as any)}
      icon="link"
      iconSize={3}
      iconAtEnd
      isPrimary
      p="0"
    >
      {children}
    </IconLink>
  );
};

type KeyValStatusDotProps = FlexProps & {
  status: StatusStyle;
  children: any;
  hasStatusDot: boolean;
};

const KeyValStatusDot = ({
  children,
  status,
  hasStatusDot,
  ...props
}: KeyValStatusDotProps): JSX.Element => {
  return (
    <Flex alignItems="center" {...(props as any)}>
      {hasStatusDot && <StatusDot mr={1} status={status} />}
      <Text variant="body2" textAlign="right">
        {children}
      </Text>
    </Flex>
  );
};

export { KeyValLink, KeyValStatusDot };
